import { useQuery } from 'react-query';

import API from 'api';
import { CATEGORIES_QUERY } from 'api/categories/categories.model';
import { CategoriesMappingModel, CATEGORY_TYPE } from 'models/documents.model';

import axiosInstance from '../utils/axios';

const useCategoriesQuery = () => {
  const categoryNames = Object.values(CATEGORY_TYPE);

  return useQuery([CATEGORIES_QUERY.GET_CATEGORIES], API.categories.getCategories, {
    select: (data) => {
      return categoryNames.reduce<CategoriesMappingModel>((result, categoryName) => {
        const categoryFromAPI = data.rows.find(({ name }) => name === categoryName);
        return { ...result, [categoryName]: categoryFromAPI?.id };
      }, {});
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 2,
    staleTime: Infinity,
    enabled: Boolean(axiosInstance.defaults.baseURL),
  });
};

export default useCategoriesQuery;
